import React from 'react';

const DunkinBadge = (props) => {
  return (
    <img
      {...props}
      src="https://cdn.shopify.com/s/files/1/0051/6295/8946/files/partnership_dunkin.png?v=1620824495"
    />
  );
};

export default DunkinBadge;
